import { create } from "zustand";
import { persist } from "zustand/middleware";
import profileService from "../services/profileService";

const useProfileStore = create(
  persist(
    (set, get) => ({
      // State
      profile: null,
      isLoading: false,
      error: null,
      message: null,

      // Actions
      getUserProfile: async () => {
        set({ isLoading: true, error: null });
        try {
          const response = await profileService.getUserProfile();
          set({
            profile: response,
            isLoading: false,
            error: null,
          });
          return response;
        } catch (error) {
          const errorMessage =
            error.message ||
            error.detail ||
            (error.non_field_errors && error.non_field_errors[0]) ||
            "Failed to fetch user profile";
          set({
            error: errorMessage,
            isLoading: false,
          });
          throw error;
        }
      },

      updateUserProfile: async (userData) => {
        set({ isLoading: true, error: null, message: null });
        try {
          const response = await profileService.updateUserProfile(userData);
          set({
            profile: { ...get().profile, ...response },
            isLoading: false,
            error: null,
            message: "Profile updated successfully!",
          });
          return response;
        } catch (error) {
          // Don't set global error for profile updates - let components handle locally
          set({
            isLoading: false,
            message: null,
          });
          throw error;
        }
      },

      changePassword: async (passwordData) => {
        set({ isLoading: true, error: null, message: null });
        try {
          const response = await profileService.changePassword(passwordData);
          set({
            isLoading: false,
            error: null,
            message: "Password changed successfully!",
          });
          return response;
        } catch (error) {
          const errorMessage =
            error.message ||
            error.detail ||
            (error.non_field_errors && error.non_field_errors[0]) ||
            "Password change failed";
          set({
            error: errorMessage,
            isLoading: false,
            message: null,
          });
          throw error;
        }
      },

      updateSettings: async (settingsData) => {
        set({ isLoading: true, error: null, message: null });
        try {
          const response = await profileService.updateSettings(settingsData);
          set({
            isLoading: false,
            error: null,
            message: "Settings updated successfully!",
          });
          return response;
        } catch (error) {
          const errorMessage =
            error.message ||
            error.detail ||
            (error.non_field_errors && error.non_field_errors[0]) ||
            "Settings update failed";
          set({
            error: errorMessage,
            isLoading: false,
            message: null,
          });
          throw error;
        }
      },

      clearError: () => {
        set({ error: null });
      },

      clearMessage: () => {
        set({ message: null });
      },

      setLoading: (loading) => {
        set({ isLoading: loading });
      },
    }),
    {
      name: "profile-storage",
      partialize: (state) => ({
        profile: state.profile,
      }),
    }
  )
);

export default useProfileStore;
